import { useState } from "react";
import api from "../lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

const EMPTY = { url: "", database: "", login: "", api_key: "" };

const FIELDS = [
  ["url", "Odoo URL", "https://yourco.odoo.com", "url"],
  ["database", "Database name", "yourco", "text"],
  ["login", "Login email", "you@yourco.com", "email"],
  ["api_key", "API key", "Paste your Odoo API key", "password"],
];

// Prompt 22 — Odoo uses an API key (no OAuth). Key is sent once and stored encrypted server-side.
export default function OdooConnectDialog({ open, onOpenChange, onConnected }) {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const close = (v) => {
    if (!v) { setForm(EMPTY); setError(""); }
    onOpenChange(v);
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/odoo/connect", form);
      setForm(EMPTY);
      onConnected(data);
      onOpenChange(false);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not connect to Odoo");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="rounded-none border-neutral-900 font-mono" data-testid="odoo-connect-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Connect Odoo</DialogTitle>
          <DialogDescription className="text-xs">
            Create an API key in Odoo under your user's Preferences → Account Security. We check it
            once with Odoo and store it encrypted. It is never shown again.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3" autoComplete="off">
          {FIELDS.map(([key, label, ph, type]) => (
            <label key={key} className="block">
              <span className="label-mini">{label}</span>
              <input
                className="input-field mt-1 w-full"
                type={type}
                required
                placeholder={ph}
                value={form[key]}
                autoComplete={type === "password" ? "new-password" : "off"}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                data-testid={`odoo-input-${key}`}
              />
            </label>
          ))}
          {error && (
            <div className="border border-red-400 bg-red-50 text-red-800 text-xs p-2" data-testid="odoo-connect-error">
              {error}
            </div>
          )}
          <DialogFooter>
            <button type="button" className="btn-outline" onClick={() => close(false)}
                    data-testid="odoo-connect-cancel">cancel</button>
            <button type="submit" className="btn-primary" disabled={busy} data-testid="odoo-connect-submit">
              {busy ? "checking…" : "connect"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
